import { render, staticRenderFns } from "./projects-charts-pft.component.vue?vue&type=template&id=0fabe836&"
import script from "./projects-charts-pft.component.vue?vue&type=script&lang=js&"
export * from "./projects-charts-pft.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports